import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import LicensedModule from "../../../../models/LicensedModule";

interface HeaderProps {
    module?: LicensedModule;
}

const WFRModuleCardHeader: React.FC<HeaderProps> = observer((props) => {
    let headerContent: React.ReactNode = null;

    return (
        <>
            {Boolean(headerContent) && (
                <Grid
                    item
                    xs={12}
                    direction={"row"}
                    wrap={"nowrap"}
                    container
                    justifyContent={"flex-start"}
                    alignItems={"center"}
                    sx={{
                        paddingLeft: 3,
                        paddingRight: 3,
                        marginTop: 3,
                        paddingBottom: 2,
                    }}
                >
                    <Grid item xs={4}>
                        {headerContent}
                    </Grid>
                    <Grid
                        item
                        xs={8}
                        container
                        justifyContent={"flex-start"}
                        alignItems={"baseline"}
                        wrap={"wrap"}
                    ></Grid>
                </Grid>
            )}
        </>
    );
});

export default WFRModuleCardHeader;
